import { Component, OnInit } from '@angular/core';
import { HeaderService } from '@app/service/header/header.service';
import { StateService } from '@app/service/state/state.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteComponent } from '@app/route/route.component';
import { SeRoute } from '@assets/val/route-constants';
import { AisAccountService, AisBank, AisProvider, BankName } from '@app/service/ais-account/ais-account.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { LoggingService } from '@app/service/logging-service/logging.service';

@Component({
  selector: 'se-ais-account',
  templateUrl: './se-ais-account.component.html',
  styleUrls: ['../../../page-shared.css', './se-ais-account.component.scss'],
})
export class SeAisAccountComponent extends RouteComponent implements OnInit {

  constructor(
    private aisAccountService: AisAccountService,
    protected stateService: StateService,
    protected headerService: HeaderService,
    protected router: Router,
    protected route: ActivatedRoute,
    private deviceDetectorService: DeviceDetectorService,
    private loggingService: LoggingService,
  ) {
    super(router, route, stateService, headerService);
  }
  
  loading: boolean = true;
  banks: AisBank[] = [];
  displayedBanks: AisBank[] = [];

  searchQuery: string = '';
  isMobile: boolean = false;

  backNavigationAllowed: boolean = false;

  async ngOnInit(): Promise<void> {
    this.isMobile = this.deviceDetectorService.isMobile();
    this.loading = true;

    try {
      this.banks = await this.aisAccountService.getBanks();
      this.updateDisplayedBanks();
      this.backNavigationAllowed = await this.aisAccountService.getAisBankBackNavigationAllowed();
    } catch (error) {
      console.error('Failed to load banks', error);
    } finally {
      this.loading = false;
    }
  }

  updateDisplayedBanks(): void {
    if (this.searchQuery) {
      this.displayedBanks = this.banks.filter(b => 
        b.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    } else {
      this.displayedBanks = this.banks;
    }
  }

  onSearch(event: any): void {
    this.searchQuery = event.target.value;
    this.updateDisplayedBanks(); 
  }

  async selectBank(aisBank: AisBank): Promise<void> {
    this.loading = true;
    const redirectUrl = SeRoute.SELECT_AIS_CALLBACK;

    let aisUrl: string;
    if (aisBank.activeProvider === AisProvider.TINK) {
      aisUrl = (await this.aisAccountService.getTinkAisUrl(redirectUrl, aisBank.tinkSelectionKey)).url; 
    } else if (aisBank.activeProvider === AisProvider.FINSHARK) {
      aisUrl = (await this.aisAccountService.getFinsharkAisUrl(redirectUrl, aisBank.finsharkSelectionKey)).url; 
    } else {
      console.error("No AIS provider detected, this is bad!");
    }
    
    if (aisUrl) {
      window.location.href = aisUrl;
    } else {
      console.error("Error fetching Tink URL - Navigation aborted!");
      this.navigate();
    }
  }

  async handleNavigateBack(): Promise<void> {
    const setResult = await this.aisAccountService.setAccountRequirement();
    if (setResult) {
      this.navigate();
    } else {
      this.loggingService.error("Couldn't set the account requirement. Backnavigation impossible, the AIS flow must be completed.");
      this.backNavigationAllowed = false;
    }
  }

  getBankDisplayName(bankKey: string): string {
    return BankName[bankKey];
  }
}
